import type { SVGProps } from 'react'

export const TwitterMonochromeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="-5 -5 34 34"
    width="1em"
    height="1em"
    focusable={false}
    {...props}
  >
    <g clipPath="url(#twitter-monochrome_svg__clip0_6_142)">
      <path
        fill="currentColor"
        d="M14.283 10.157 23.218 0h-2.117l-7.758 8.819L7.147 0H0l9.37 13.336L0 23.988h2.117l8.192-9.313 6.544 9.314H24l-9.717-13.831h.001zm-2.9 3.297-.949-1.328L2.88 1.559h3.252l6.096 8.528.949 1.328L21.102 22.5H17.85l-6.466-9.045z"
        clipPath="url(#twitter-monochrome_svg__clip0_6_142)"
      />
    </g>
  </svg>
)
